<template>
	<form class="qna-comment" @submit.prevent="register">
		<ManagingSection>
			<ManagingBox
				:title="`${qnaType === 'reply' ? '질문 번호' : '답변 번호'}`"
			>
				<div>{{ replyId }}</div>
			</ManagingBox>
			<ManagingBox title="작성자">
				<SearchBrand
					@change="idBrandChange"
					ref="SearchBrand"
					searcher-placeholder="브랜드명를 입력하세요"
					selected-placeholder="브랜드를 선택해 주세요"
					:use-last-brand="false"
					:show-if-is-display="true"
				/>
			</ManagingBox>
			<ManagingBox title="내용">
				<TextCounter
					v-model="text"
					:useTextarea="true"
					:useLineLimit="false"
					:maxLength="1000"
					:useComma="true"
					:textCounterType="'reply'"
				/>
			</ManagingBox>
			<ManagingBox title="연관 제품">
				<div class="qna-comment__search-product">
					<ProductSearcher2 @change="searchProduct" />
				</div>
				<table class="table-inner qna-comment__table">
					<tr>
						<th class="table-id">제품항번</th>
						<th class="table-img">이미지</th>
						<th class="table-brand">브랜드명</th>
						<th class="table-product">제품명</th>
						<th class="table-display">노출</th>
						<th class="table-discontinued">단종</th>
						<th class="table-remove">제거</th>
					</tr>
					<tr v-if="productList.length === 0">
						<td colspan="7">등록된 제품이 없습니다.</td>
					</tr>
					<tr v-for="item in productList" :key="item.idProduct">
						<td>{{ item.idProduct }}</td>
						<td>
							<figure>
								<img
									:src="item.filePath"
									class="qna-comment__product-img"
								/>
							</figure>
						</td>
						<td>{{ item.brandTitle }}</td>
						<td>{{ item.productTitle }}</td>
						<td>
							<span v-if="item.isDisplay">노출</span>
							<span v-else class="red--text">미노출</span>
						</td>
						<td>
							<span v-if="item.isDiscontinue" class="red--text"
								>단종</span
							>
							<span v-else>정상</span>
						</td>
						<td>
							<button
								type="button"
								class="btn-minus"
								@click="removeProduct(item.idProduct)"
							>
								<i class="fa fas fa-minus"></i>
							</button>
						</td>
					</tr>
				</table>
			</ManagingBox>
			<ManagingBox title="연관 캐스트">
				<div class="qna-comment__search-product">
					<SearchCast
						search-placeholder="캐스트 검색 (항번으로만 검색)"
						cast-search-type="castId"
						@change="castChange"
					/>
				</div>
				<table class="table-inner qna-comment__table">
					<tr>
						<th class="table-id">캐스트 항번</th>
						<th class="table-img">이미지</th>
						<th class="table-product">캐스트명</th>
						<th class="table-remove">제거</th>
					</tr>
					<tr v-if="castList.length === 0">
						<td colspan="4">등록된 캐스트가 없습니다.</td>
					</tr>
					<tr v-for="item in castList" :key="item.idProduct">
						<td>{{ item.idPouch }}</td>
						<td>
							<figure>
								<img :src="item.pouchImageUrl" />
							</figure>
						</td>
						<td>{{ item.pouchTitle }}</td>
						<td>
							<button
								type="button"
								class="btn-minus"
								@click="removeCast(item.idPouch)"
							>
								<i class="fa fas fa-minus"></i>
							</button>
						</td>
					</tr>
				</table>
			</ManagingBox>
			<div class="btn-wrap-main">
				<button
					class="btn-main"
					type="button"
					v-text="'취소'"
					@click="$router.go(-1)"
				/>
				<button class="btn-main blue" type="submit" v-text="'등록'" />
			</div>
		</ManagingSection>
	</form>
</template>
<script>
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import SearchBrand from '@/components/SearchBrand.vue';
	import ProductSearcher2 from '@/components/ProductSearcher2';
	import TextCounter from '@/components/TextCounter.vue';
	import SearchCast from '@/components/SearchCast.vue';

	export default {
		components: {
			ManagingSection,
			ManagingBox,
			SearchBrand,
			ProductSearcher2,
			TextCounter,
			SearchCast,
		},
		data() {
			return {
				text: '',
				officialRefId: null,
				productList: [],
				castList: [],
				MAX_PRODUCTS: 5,
				castListId: [],
			};
		},
		props: {
			replyId: {
				type: [String, Number],
				default: '',
			},
			qnaType: {
				type: String,
				default: 'reply',
			},
		},
		methods: {
			checkProduct(list) {
				if (list.length >= this.MAX_PRODUCTS) {
					alert('최대 5개까지 등록이 가능합니다.');
					return false;
				}
				return true;
			},

			castChange(cast) {
				if (!cast) return;
				const hasCast = this.castList.some(
					item => item.idPouch === cast.idPouch
				);

				if (!this.checkProduct(this.castList)) return;

				if (!hasCast) {
					this.castList = [...this.castList, cast];
				} else {
					alert('이미 추가된 캐스트입니다.');
				}
			},

			idBrandChange(changes) {
				this.officialRefId = changes.idBrand;
			},
			searchProduct(productId) {
				if (!productId) return;

				const hasProduct = this.productList.some(
					item => item.idProduct === productId.idProduct
				);

				if (!this.checkProduct(this.productList)) return;

				if (!hasProduct) {
					this.productList = [...this.productList, productId];
				} else {
					alert('이미 추가된 제품입니다.');
				}
			},
			removeProduct(id) {
				const product = this.productList.filter(
					item => item.idProduct !== id
				);
				this.productList = product;
			},
			removeCast(id) {
				this.castList = this.castList.filter(
					item => item.idPouch !== id
				);
			},

			validation() {
				if (!this.officialRefId) {
					alert('작성자를 입력해주세요');
					return false;
				}
				if (this.text.length === 0) {
					alert('내용을 입력해주세요');
					return false;
				}
				return true;
			},

			async register() {
				if (!this.validation()) return false;
				const castListId = this.castList.map(item => item.idPouch);
				const productListId = this.productList.map(
					item => item.idProduct
				);
				try {
					const params = {
						text: this.text,
						officialRefType: 'brand',
						officialRefId: this.officialRefId,
						productIdList: [...productListId],
						pouchIdList: [...castListId],
					};

					if (this.qnaType === 'reply') {
						params.qnaId = this.replyId;
					}

					if (this.qnaType === 'comment') {
						params.qnaId = this.$route.query.qId;
						params.parentId = this.replyId;
					}

					this.$emit('register', params);
				} catch (err) {
					console.error(err);
				}
			},
		},
	};
</script>
<style lang="scss" , scooped>
	.qna-comment {
		&__search-product {
			width: 1000px;
			margin: 10px 0;
		}

		.table-id,
		.table-display,
		.table-discontinued,
		.table-remove {
			width: 70px;
		}

		.table-img {
			width: 200px;
		}

		&__product-img {
			width: 70px;
		}
	}
	.red--text {
		color: $red;
	}
</style>
